<template>
<div class="page page_baocuo page_map page_publish">
	<div class="search_fenlei">
		<div class="fenlei_title">文章分类</div>
		<ul class="search_list clearfix">		
			<li :class="item.status ? 'search_item active f-l' : 'search_item f-l'" v-for="item in cateList" :key="item.f_id" @click="selectCate(item)">{{ item.f_name }}</li>
		</ul>
	</div>
    <div class="filed">
        <div class="filed_title">发布内容</div>
        <div class="filed_nr">
            <van-field v-model="comment" :border="false" type="textarea" maxlength="200" placeholder="请您输入...." @input="inputFun" />
			<!-- 字数统计 -->
        	<div class="count_num">{{num +'/200'}}</div>
        </div>
    </div>
	<div class="filed">
        <div class="filed_title">上传图片</div>
        <div class="filed_nr">
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po">
                        <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" />
                    </div>
                    <div class="del" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept multiple class="icon-add" ref="addPhone">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
        </div>
    </div>
    <div class="actions">
        <div class="bottom_action" @click="tijiaoFun">发布</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
			token: null,
			comment: '',
			imglist: [],
			cateList: [], // 分类列表
			cate_id: null, // 分类id
			num: 0 // 输入字数
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '发布头条'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
		}
		this.getCateList()
    },
    methods: {
		// 分类
		getCateList(){
			var params = {
				token: this.token
			}
			this.$api.toutiao.cateList(params).then(res=>{
				if(res.code == 200){
					var list = res.result
					for(var i in list){
						list[i].status = 0
					}
					this.cateList = res.result
				}
			})
		},
		// 选择分类
		selectCate(item){
			var status = item.status
			for(var i in this.cateList){
				if(this.cateList[i].f_id == item.f_id){
					if(item.status == 0 ){
						this.cateList[i].status = 1
						this.cate_id = this.cateList[i].f_id
					}else if(item.status == 1){
						this.cateList[i].status = 0
					}
					
				}else{
					this.cateList[i].status = 0
				}
			}
		},
		// 上传图片
		onRead: function (file) {
            console.log("file");
            console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.imglist.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.imglist.push(res.result.url);
                    }
                });
            }
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
		},
		// 提交
		tijiaoFun(){
			if(this.cate_id == null || this.cate_id == undefined || this.cate_id == ''){
				this.$toast('请选择文章分类')
				return
			}
			if(!this.comment){
				this.$toast('请填写内容')
				return
			}
			var params = {
				token: this.token,
				content: this.comment,
				cate_id: this.cate_id
			}
			if(this.imglist.length !=0 ){
				var strImages = this.imglist.join()
				params.images = strImages
			}
			// console.log(params)
			this.$api.toutiao.create(params).then(res=>{
				if(res.code == 200){
                    this.$toast('发布成功,请等待审核')
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        //返回上级页面
                        var params = {'data':{}}
                        this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                        })
                    } else {
                        this.$router.push({
                            path:　'/toutiao/index'
                        })
                    }
				} else {
                    this.$toast(res.message)
                }
			})
		},
		// 字数统计
        inputFun(value) {
            console.log(value)
            if (this.num <= 200) {
                this.num = value.length
            } else {
                this.num = 200
            }

        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	.page .upload-images {
		margin-top: .4rem;
	}
</style>
